import {NgModule, Component, OnInit, Output, EventEmitter, Input,} from '@angular/core';
import {DropdownModule,SelectItem} from 'primeng/primeng';


import {TypeError} from "../../error/error";
import {MamAdminService} from "../../service/mam_service.component";

import {Logger, Options, Level } from "angular2-logger/core";
import {CommonModule} from "@angular/common";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms"; // ADD THIS

@Component({
  selector: 'ex-company-drop-down-list',
  templateUrl: './company-drop-down-list.component.html',
  styleUrls: ['./company-drop-down-list.component.css']
})
export class CompanyDropDownListComponent implements OnInit {

  company_list:SelectItem[] = [];
  selected_company: any;
  @Input() existCompany : any;
  @Output() onSelect:EventEmitter<any> = new EventEmitter();

  constructor(private service:MamAdminService, private logger : Logger) { }

  ngOnInit() {
    this.loadCompanyList();
  }

  private loadCompanyList():void{
    var url = "/mgr/system/company/list";
    this.service.get(url,null,null).subscribe(
      list=>{
        this.logger.debug("company_list : ",list);

        for (let company of list){
          this.company_list.push({label:company.name, value:company});
        };
      }
      ,err=>{this.logger.error("loadCompanyList",err)}
      ,()=>{
        this.logger.debug("loadCompanyList complate",this.company_list[0]);
        if(this.existCompany && this.existCompany.id > 0){
          this.selected_company = this.existCompany;
        }else{
          this.selected_company = this.company_list[0].value;
        }
        if(this.onSelect != null){
          this.onSelect.emit(this.selected_company);
        }
      }
    );
  }

  private onCompanySelected(event:any):void{
    this.logger.debug("slected company : ", event);
    if(this.onSelect != null){
      this.onSelect.emit(event.value);
    }
  }
}



@NgModule({
    imports:[CommonModule, BrowserModule, FormsModule, DropdownModule],
    declarations:[CompanyDropDownListComponent],
    exports:[CompanyDropDownListComponent],
    providers:[MamAdminService]
})
export class CompanyDropDownListModule{
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/company-drop-down-list/company-drop-down-list.component.ts